import React from 'react';
import styles from './MyTipsTipBox.module.scss';
import SVG from 'react-inlinesvg';

//Translations
import { useTranslation } from 'react-i18next';
import {
  MatchFromBE,
  UnlockedMatchForecast,
  UnlockedTipData,
} from '../../store/tips/reducer';
import { fullDateFormatter } from '../TipPublish/utils/fullDateFormatter';
import { getSportIcon } from '../TipPublish/utils/icons/getSportIcon';
import { TipResultDot } from '../Shops/Tip/components/TipBox/ResultDot/TipResultDot';
import { tr } from '../../utils/translations/translator';

interface MyTipsMatchForecastInfoProps {
  tip: UnlockedTipData;
  match: MatchFromBE | undefined;
  forecast: UnlockedMatchForecast;
}

export const MyTipsMatchForecastInfo: React.FC<
  MyTipsMatchForecastInfoProps
> = ({ tip, match, forecast }) => {
  const { t } = useTranslation();

  return (
    <>
      {match ? (
        <div className={styles.match} key={match.id}>
          <div className={styles.topRow}>
            <span className={styles.text}>
              {match.home_player}
              {match.away_player.length ? ` - ${match.away_player}` : ''}
            </span>

            <span className={styles.date}>
              {fullDateFormatter(match.start_date)}
            </span>
          </div>

          <div className={styles.sportsContainer}>
            <SVG src={getSportIcon(match.sport_code)} />

            {tr(t, match.sport)}

            {' - '}

            {match.competition_name}
          </div>

          <div className={styles.pickInfo}>
            <div className={styles.line} />

            <div className={styles.pickMsgAndResult}>
              <TipResultDot result={tip.result} />

              <div className={styles.pickAndMarket}>
                <div className={styles.pick}>
                  <span className="font-black text-sm -mt-1 -ml-1 mr-1 text-black">
                    {forecast.pick}
                  </span>

                  <span className={styles.pickIcon}>
                    {tr(t, 'tip').toUpperCase()}
                  </span>
                </div>

                <span className={styles.market}>
                  {t(`markets:bet_markets_${forecast.market_code}`).replace(
                    'bet_markets_',
                    '',
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
